export interface TopFiveMetrics {
  period: Period;
  insightCreatedDate: Date;
  metrics: Metric[];
}

interface Period {
  // Today, only valid value is 'day'
  type: string;
  from: Date;
  // Today, only valid value is '30'
  value: number;
}

export interface Metric {
  isIncreaseBeneficial: boolean;
  percentageChange: number;
  previousValue: number;
  currentValue: number;
  type: MetricType;
}

export enum MetricType {
  AVERAGE_REVIEWER_LATENCY_HOURS = 'average_reviewer_latency_hours',
  AVERAGE_REVIEW_LIFECYCLE_HOURS = 'average_review_lifecycle_hours',
  AVERAGE_INLINE_COMMENTS = 'average_inline_comments',
  AVERAGE_DEFECTS = 'average_defects',
  AVERAGE_COMMENTS_PER_REVIEW = 'average_comments_per_review',
  AVERAGE_LINE_COUNTS_PER_REVIEW = 'average_line_counts_per_review',
  AVERAGE_TEST_LINE_COUNTS_PER_REVIEW = 'average_test_line_counts_per_review',
  DEFECT_RATE = 'defect_rate',
  PERCENT_TEST_LINES_PER_REVIEW = 'percent_test_lines_per_review',
  TOTAL_CODE_REVIEWS_COMPLETED = 'total_code_reviews_completed',
  TOTAL_INLINE_COMMENTS = 'total_inline_comments',
  TOTAL_DEFECTS = 'total_defects',
  TOTAL_COMMENTS = 'total_comments',
  TOTAL_LINE_COUNTS = 'total_line_counts',
  TOTAL_TEST_LINE_COUNTS = 'total_test_line_counts',
  TOTAL_DELETIONS = 'total_deletions',
  TOTAL_ADDITIONS = 'total_additions',
}
